// extracted by mini-css-extract-plugin
module.exports = {"login_page":"index_login_page__1sYMo","hidden":"index_hidden__1J7LR"};